<template>
    <basic-layout class="ma-4">
        <v-container class="fill-height " fluid>
            <v-row align="center" justify="center">
                <v-col cols="12" sm="8" md="4" >
                    <main-title/>
                    <div class="font-weight-light primary--text mb-6 text-center">
                        <p class="mt-3" v-if="!errors">Hello Admin! Please input your valid credentials.</p>
                        <p class="mt-3 red--text" v-else>{{errors.email[0]}}</p>
                        <v-alert v-if="alert.text" dense text :type="alert.type">
                            {{alert.text}}
                        </v-alert>
                    </div>
                    <v-form v-model="valid" ref="form">
                        <v-text-field label="Email"
                                      class="form-control uppercase"
                                      name="email"
                                      :rules="rules.fieldRules"
                                      v-model="form.email"
                                      prepend-icon="mail"
                                      type="text"/>
                        <v-text-field id="password" label="Password"
                                      class="form-control"
                                      name="password"
                                      :rules="rules.fieldRules"
                                      v-model="form.password"
                                      :append-icon="e1 ? 'visibility' : 'visibility_off'"
                                      :type="!e1 ? 'password' : 'text'"
                                      @click:append="() => (e1 = !e1)"
                                      required prepend-icon="lock"/>
                        <v-btn block class="mt-5" :loading="loggingin" :disabled="loggingin" color="primary" @click.prevent="login">
                            Login
                            <template v-slot:loader>
                                <span>Please wait...</span>
                            </template>
                        </v-btn>
                    </v-form>
                </v-col>
            </v-row>
        </v-container>
    </basic-layout>
</template>

<script>
    import user from "../../../api/user";
    export default {
        name: 'Welcome',
        data() {
            return {
                e1: false,
                valid: false,
                loading: false,
                message: '',
                loggingin: false,
                errors: null,
                form: {
                    email: '',
                    password: '',
                    device_name: 'browser',
                },
                rules: {
                    fieldRules: [
                        v => !!v || 'This field is required',
                    ],

                }
            };
        },
        computed: {
            alert(){
                return this.$store.getters.getAlert;
            }
        },
        created() {

        },
        methods: {
            login() {
                if(this.$refs.form.validate()){
                    this.loggingin = true;
                    user.adminLogin(this.form)
                        .then(response =>{
                            this.middleware(response);
                        })
                        .catch(error =>{
                            this.loggingin = false;
                            this.errors = error.response.data.errors;
                        })
                }
            },
            async middleware(response){
                await  localStorage.setItem("token",response.data);
                await  this.$store.dispatch('setCurrentUser');
                this.loggingin = false;
                await  this.$router.push({name: "AdminPanel"})
            },
        }
    }
</script>

<style scoped>

</style>